// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-info-chip--IOJ7h{padding:4px 8px;background-color:#f0f0f4;border:none;color:#393f4c;transition:background-color .15s ease,color .15s ease}.video-info-chip__icon--gaHOO{font-size:16px;color:inherit}.video-info-chip__label--F055X{color:inherit;font-size:12px}.video-info-chip--interactive--qG8Kz{cursor:pointer;background-color:#eeecfe}.video-info-chip--interactive--qG8Kz:hover{color:#5645f5}.video-info-chip--interactive--qG8Kz:focus-visible{outline:2px solid #5645f5;outline-offset:2px}.video-info-chip--disabled--EZka_{cursor:default}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-info-chip": "video-info-chip--IOJ7h",
	"video-info-chip__icon": "video-info-chip__icon--gaHOO",
	"video-info-chip__label": "video-info-chip__label--F055X",
	"video-info-chip--interactive": "video-info-chip--interactive--qG8Kz",
	"video-info-chip--disabled": "video-info-chip--disabled--EZka_"
};
export default ___CSS_LOADER_EXPORT___;
